const TRADES = [
  "Personal Injury Law", "Dental", "Chiropractic", "Med Spas", "Orthodontics", "Dermatology",
  "Physical Therapy", "Optometry", "Family Law", "Roofing", "HVAC", "Plumbing",
];

export default function Marquee() {
  const items = [...TRADES, ...TRADES];
  return (
    <section data-testid="industries-marquee" className="relative overflow-hidden border-y border-navy/5 bg-mist py-6">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-mist to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-mist to-transparent" />
      <div className="flex overflow-hidden no-scrollbar">
        <div className="marquee-track flex shrink-0 items-center gap-10 pr-10 animate-marquee">
          {items.map((t, i) => (
            <span key={i} className="flex items-center gap-10 whitespace-nowrap">
              <span className="font-display text-lg font-semibold text-navy/70 sm:text-xl">{t}</span>
              <span className="h-1.5 w-1.5 rounded-full bg-brand-indigo/40" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
